import { arrType, datatypes, inputTypes } from "data/globalData";

const multiSelect = (name, key) => ({
	name,
	key,
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	select_options: {
		type: arrType,
		list: [{ name: "Loading...", key: "Loading" }],
	},
});

export const filterColArry = [
	{
		name: "Start Date",
		key: "start_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	{
		name: "End Date",
		key: "end_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	multiSelect("Channel", "CHANNEL"),
	multiSelect("Brand", "BRAND"),
	multiSelect("Division", "DIVISION"),
	multiSelect("Department", "DEPARTMENT"),
	multiSelect("Season", "SEASON"),
	multiSelect("Sub Brand", "SUB_BRAND"),
];
